export default __webpack_public_path__ + "media/images/theme/bg_light_backup-cf45526c8e60467287c23ddce4c5e490.png";